import { Link } from "@remix-run/react";
import { Loader2 } from "lucide-react";

import { Alert, AlertDescription, AlertTitle } from "../ui/alert";
import { Button } from "../ui/button";
import { A } from "../ui/typography";

export const PromotionBanner = () => (
    <Alert className="text-brand-forest-800 bg-brand-forest-50 flex items-center rounded-none border-x-0 border-t-0">
        <img
            src="/parts-companion-logomark.png"
            alt="A Home for All Your Parts"
            className="mr-4 w-full max-w-[60px] rounded-md object-cover"
        />
        <div className="max-w-5xl flex-col items-start justify-start">
            <AlertTitle>A Home for All Your Parts</AlertTitle>
            <AlertDescription className="flex items-center justify-between">
                <span className="">
                    This session report was generated by Parts Companion. Parts
                    Companion is a free resource thatsupports clients and
                    practitioners on the work they do together.
                    <br />
                    <A href="/landing">Sign up now</A> to explore with your own
                    sessions.
                </span>
            </AlertDescription>
        </div>
    </Alert>
);
